export default function selectDetailClass(strMeal) {
  return strMeal ? 'food-detail' : 'drink-detail';
}
